<template>
    <a-modal
        title="打卡"
        :visible="visible"
        class="modal-initialize"
        width="508px"
        @cancel="cancelFun"
        @ok="okFun"
    >
        <div class="bomb-remind">
            <div class="bomb-form">
                <a-form class="inline-form" :form="form">
                    <a-form-item label="打卡类型" v-bind="formItemLayout">
                        <a-select
                            style="width: 100%;"
                            v-decorator="['type',{rules: [{ required: true, message: '请选择打卡类型' }]} ]"
                            placeholder="请选择打卡类型"
                        >
                            <a-select-option key="1" value="1">上课</a-select-option>
                            <a-select-option key="2" value="2">下课</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label="打卡时间" v-bind="formItemLayout">
                        <a-date-picker
                            :show-time="{ format: 'HH:mm' }"
                            format="YYYY-MM-DD HH:mm"
                            style="width: 100%"
                            placeholder="请选择打卡时间"
                            v-decorator="['datetime',{rules: [{ required: true, message: '请选择打卡时间' }]} ]"
                        />
                    </a-form-item>
                </a-form>
            </div>
        </div>
    </a-modal>
</template>

<script>
import moment from "moment";

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        csid: {
            type: String,
            default: ''
        },
        clid: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            formItemLayout: {
                labelCol: {
                    span: 6
                },
                wrapperCol: {
                    span: 18
                },
            },
            dateFormat: 'YYYY-MM-DD HH:mm',
        };
    },
    watch: {
        // 实现双向绑定
        visible(val) {
            if (val === false) {
                this.form.resetFields(); // 重置表单
            } else {
                this.getData();
            }
        },
    },
    model: {
        prop: 'visible',
        // 这个事件名可以随意写，它实际上是规定了子组件要更新父组件值需要注册的方法
        event: 'changeVisible'
    },
    methods: {
        closeModal() {
            this.$emit('changeVisible', false);
        },
        getData() {
        },
        okFun() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {

                        let url = '/manage/clesson/study';

                        values.csid = this.csid;
                        values.clid = this.clid;
                        values.datetime = values.datetime ? values.datetime.format(this.dateFormat) : '';

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'});
                            this.closeModal();
                            this.$emit("confirm");
                        }, null, 1);
                    }
                }
            );
        },
        cancelFun() {
            this.closeModal();
        },
    }
}
</script>